import { AuthRoute } from "../../components/public/auth/AuthRoute";

export const SignUp = () => <AuthRoute view="signup" />;
